module.exports = __webpack_public_path__ + "media/getincome_top.768f1393.mp4";